import * as highestOverallMonth from "../StatsTable/getHighestOverallMonth";
import * as highestOverallDay from "../StatsTable/getHighestOverallDay";
import * as highestNumberOfSalesIOneDay from "../StatsTable/getHighestNumberOfSalesOneDay";
import * as highestIndividualSaleOneMonth from "../StatsTable/getHighestIndividualSaleOneMonth";
import * as highestIndividualProfit from "../StatsTable/getHighestIndividualProfit";
import * as highestIndividualSale from "../StatsTable/getHighestIndividualSale";
import * as highestProfitMonth from "../StatsTable/getHighestProfitMonth";
import * as mostExchangeTransactions from "../StatsTable/getMostExchangTransaction";
import * as mostExchangeRevenue from "../StatsTable/getMostExchangeRevenue";

export default [
  {
    title: "Highest Overall Month",
    config: highestOverallMonth
  },
  {
    title: "Highest Overall Day",
    config: highestOverallDay
  },
  {
    title: "Highest # sales in 1 day",
    config: highestNumberOfSalesIOneDay
  },
  {
    title: "Highest Individual sales (1 mo)",
    config: highestIndividualSaleOneMonth
  },
  {
    title: "Highest Individual Profit (1 mo)",
    config: highestIndividualProfit
  },
  {
    title: "Highest Individual Sales Credit",
    config: highestIndividualSale
  },
  {
    title: "Highest Profit Month",
    config: highestProfitMonth
  },
  {
    title: "Most Exchange Transaction Month",
    config: mostExchangeTransactions
  },
  {
    title: "Most Exchange Revenue Month",
    config: mostExchangeRevenue
  }
];



// WEBPACK FOOTER //
// ./app/modules/HighScores/components/Report/reports.js